import { FunctionComponent, ReactNode } from "react";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import { Icon } from "@/components";

interface SignpostCardProps {
	icon: IconDefinition;
	title: string;
	description: string;
	/** Action buttons rendered centered under the description. */
	actions: ReactNode;
}

/**
 * Centered call-to-action card shown in place of the campaign sequence when there is
 * no campaign to display for the current lead (Ready to send / Outbox campaign tab).
 */
export const SignpostCard: FunctionComponent<SignpostCardProps> = ({
	icon,
	title,
	description,
	actions,
}) => (
	<div className="w-full h-full flex items-center justify-center p-6">
		<div className="bg-white border border-border-light rounded-2xl shadow-md px-9 py-9 max-w-[440px] text-center">
			<div className="w-14 h-14 rounded-xl bg-brand-white mx-auto mb-4 flex items-center justify-center">
				<Icon className="w-6 h-6 text-brand-light" icon={icon} />
			</div>
			<h3 className="text-lg font-bold mb-2">{title}</h3>
			<p className="text-sm text-text-meta mb-6 leading-relaxed">{description}</p>
			<div className="flex gap-3 justify-center">{actions}</div>
		</div>
	</div>
);
